import React from 'react';
import Logo from './Logo';
import './ErrorScreen.css';

const ErrorScreen = ({ title = 'Error', message = 'Something went wrong', onRetry }) => (
  <div className="error-screen">
    <div className="error-screen__container">
      <Logo variant="named" size={132} alt="Crew Core" />
      <div className="error-screen__icon" aria-hidden="true">
        <span>!</span>
      </div>
      <h1>{title}</h1>
      <p>{message}</p>
      {onRetry && (
        <button type="button" className="error-screen__button" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  </div>
);

export default ErrorScreen;
